import React from 'react';
import { getCurrentLanguage, setLanguageUrlParam } from '../utils/languageUtils';
import LanguageFlag from './LanguageFlag';
import './LanguageSelector.scss';

const LanguageSelector = React.memo(function LanguageSelector({ languages }) {
  const currentLang = getCurrentLanguage();
  const selectedLang = languages.some(({ value }) => value === currentLang) ? currentLang : languages[0]?.value;
  const selectedOption = languages.find(({ value }) => value === selectedLang) || languages[0];

  const handleChange = (e) => {
    const lang = e.target.value;
    if (lang && lang !== getCurrentLanguage()) {
      window.location.assign(setLanguageUrlParam(lang));
    }
  };

  return (
    <div className="af-language-selector">
      <div className="af-language-selector__control">
        <span className="af-language-selector__display" aria-hidden="true">
          <LanguageFlag flag={selectedOption?.flag} />
          <span className="af-language-selector__label">{selectedOption?.label}</span>
        </span>
        <select id="af-language-select" className="af-language-selector__select" value={selectedLang} onChange={handleChange} aria-label="Language">
          {languages.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
});

export default LanguageSelector;
